import { Link } from "react-router-dom";
import privateRoutes from "src/routes/private-routes";

import * as sidebarSandboxAnalyticEvents from "src/consts/analytic-events/sandbox/sidebar";
import * as sidebarLiveAnalyticsEvents from "src/consts/analytic-events/sidebar";
import { BIG_FLIP_HELP_CENTER } from "src/consts/links";
import { RBAC_KEY } from "src/consts/rbac";
import { logEventClicked } from "src/helpers/amplitude/analytics-helpers";
import * as PERMISSIONS from "./permission-group-menu";

const help_center = {
  label: ["Pusat Bantuan", "Help Center"],
  as: "a",
  icon: "ask",
  show: true,
  active_url_prefixes: ["help"],
  to: `${BIG_FLIP_HELP_CENTER}?source=ffb&origin=${window.location.host}`,
  additional_link_attributes: {
    target: "_blank",
    rel: "noopenner noreferrer"
  },
  key: RBAC_KEY.HELP_CENTER
};

export const MENUS = {
  home: {
    label: ["Beranda", "Home"],
    as: Link,
    to: privateRoutes.home.path,
    icon: "home",
    active_url_prefixes: ["home"],
    show: true,
    key: RBAC_KEY.HOME,
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_HOME);
    }
  },
  send_money: {
    label: ["Money Transfer", "Money Transfer"],
    as: Link,
    to: privateRoutes.transaction.path,
    icon: "send",
    active_url_prefixes: ["transaction", "history", "approval", "beneficiary"],
    show: true,
    key: PERMISSIONS.MONEY_TRANSFER_RBAC,
    childs: [
      {
        label: ["Buat Transaksi", "New Transaction"],
        path: [privateRoutes.transaction.path],
        key: RBAC_KEY.MONEY_TRANSFER_NEW_TRX,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MONEY_TRANSFER_NEW);
        }
      },
      {
        label: ["Riwayat Transaksi", "Transaction History"],
        path: [privateRoutes.historyTransaction.path, privateRoutes.historyTransactionDetail.path],
        key: RBAC_KEY.MONEY_TRANSFER_HISTORY,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MONEY_TRANSFER_TRANSACTION_HISTORY);
        }
      },
      {
        label: ["Laporan Transaksi", "Transaction Report"],
        path: [privateRoutes.historyTransactionReport.path],
        key: RBAC_KEY.MONEY_TRANSFER_REPORT,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MONEY_TRANSFER_TRANSACTION_REPORT);
        }
      },
      {
        label: ["Persetujuan", "Approval"],
        path: [privateRoutes.approval.path],
        key: RBAC_KEY.APPROVAL,
        active_url_prefixes: ["approval"],
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MONEY_TRANSFER_APPROVAL);
        }
      },
      {
        label: ["Daftar Penerima", "Beneficiary List"],
        path: [
          privateRoutes.beneficiaryList.path,
          privateRoutes.beneficiaryUpload.path,
          privateRoutes.beneficiaryReview.path
        ],
        key: RBAC_KEY.BENEFICIARY_LIST,
        active_url_prefixes: ["beneficiary"],
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MONEY_TRANSFER_BENEFICIARY_LIST);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MONEY_TRANSFER_NEW);
    }
  },
  international_transfer: {
    label: ["International Transfer", "International Transfer"],
    as: Link,
    to: privateRoutes.internationalTransaction.path,
    icon: "send-abroad",
    active_url_prefixes: ["international-transaction", "history"],
    show: true,
    key: PERMISSIONS.INTERNATIONAL_TRANSFER_RBAC,
    childs: [
      {
        label: ["Buat Transaksi", "New Transaction"],
        path: [privateRoutes.internationalTransaction.path],
        key: RBAC_KEY.INTERNATIONAL_TRANSFER_NEW_TRX,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_INTERNATIONAL_TRANSFER_NEW);
        }
      },
      {
        // "Persetujuan Transaksi" (.plans/feature_maker-approver-itr_plan.md, A10). Gated only by
        // `RBAC_KEY` here (so it shows for MAKER/APPROVER/ADMIN/EXECUTOR, the read group) -- the
        // route-level Nexus toggle gate (`pages/TransactionApproval/lazy.tsx` etc.) is what redirects
        // away when `dis-flag-itr-maker-approver-flow` is off, matching how `dis-flag-new-itr-flow`
        // is already gated (route/page level, never in this static menu config). `menus.js` has no
        // hook access, so it cannot read the toggle itself -- making `MENUS` hook-driven is a
        // separate ticket, not done here. The payment route is deliberately NOT in this entry's
        // `path` list (it is ADMIN/APPROVER only, not the whole read group, and has no menu
        // affordance of its own -- it is only ever reached via an action button).
        label: ["Persetujuan Transaksi", "Transaction Approval"],
        path: [
          privateRoutes.internationalTransactionApproval.path,
          privateRoutes.internationalTransactionApprovalReview.path
        ],
        key: RBAC_KEY.INTERNATIONAL_TRANSFER_APPROVAL,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_INTERNATIONAL_TRANSFER_APPROVAL);
        }
      },
      {
        label: ["Riwayat Transaksi", "Transaction History"],
        path: [
          privateRoutes.historyInternationalTransaction.path,
          privateRoutes.historyInternationalTransactionDetail.path
        ],
        key: RBAC_KEY.INTERNATIONAL_TRANSFER_HISTORY,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_INTERNATIONAL_TRANSFER_TRANSACTION_HISTORY);
        }
      },
      {
        label: ["Laporan Transaksi", "Transaction Report"],
        path: [privateRoutes.historyInternationalTransactionReport.path],
        key: RBAC_KEY.INTERNATIONAL_TRANSFER_REPORT,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_INTERNATIONAL_TRANSFER_TRANSACTION_REPORT);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_INTERNATIONAL_TRANSFER_NEW);
    }
  },
  accept_payment: {
    label: ["Accept Payment", "Accept Payment"],
    as: Link,
    to: privateRoutes.acceptPayment.path,
    icon: "receive",
    active_url_prefixes: ["accept-payment"],
    show: true,
    key: PERMISSIONS.ACCEPT_PAYMENT_RBAC,
    childs: [
      {
        label: ["Link Pembayaran", "Payment Links"],
        path: [privateRoutes.acceptPayment.path],
        key: RBAC_KEY.ACCEPT_PAYMENT_NEW,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_ACCEPT_PAYMENT_NEW);
        }
      },
      {
        label: ["ID & Konfigurasi", "ID & Configuration"],
        path: [privateRoutes.acceptPaymentConfiguration.path, privateRoutes.acceptPaymentFlipCheckoutPage.path],
        key: RBAC_KEY.ACCEPT_PAYMENT_CONFIGURATION,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_ACCEPT_PAYMENT_ID_CONFIG);
        }
      },
      {
        label: ["Riwayat Pembayaran", "Payment History"],
        path: [privateRoutes.acceptPaymentHistory.path],
        key: RBAC_KEY.ACCEPT_PAYMENT_HISTORY,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_ACCEPT_PAYMENT_HISTORY);
        }
      },
      // PRD MD-2.2: "Riwayat Refund" sits under Accept Payment, directly below
      // "Riwayat Pembayaran" — this position is what places it there, so keep the two adjacent.
      {
        label: ["Riwayat Refund", "Refund History"],
        path: [privateRoutes.acceptPaymentRefundHistory.path],
        key: RBAC_KEY.ACCEPT_PAYMENT_REFUND_HISTORY,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_ACCEPT_PAYMENT_REFUND_HISTORY);
        }
      },
      {
        label: ["Laporan Pembayaran", "Payment Report"],
        path: [privateRoutes.acceptPaymentReport.path],
        key: RBAC_KEY.ACCEPT_PAYMENT_REPORT,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_ACCEPT_PAYMENT_REPORT);
        }
      },
      {
        label: ["Laporan Settlement", "Settlement Report"],
        path: [privateRoutes.acceptPaymentSettlementReport.path],
        key: RBAC_KEY.ACCEPT_PAYMENT_SETTLEMENT_REPORT,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_ACCEPT_PAYMENT_SETTLEMENT_REPORT);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_ACCEPT_PAYMENT_NEW);
    }
  },
  deposit: {
    label: ["Deposit Saya", "My Deposit"],
    as: Link,
    to: privateRoutes.deposit.path,
    icon: "wallet",
    active_url_prefixes: ["deposit"],
    show: true,
    key: PERMISSIONS.DEPOSIT_RBAC,
    childs: [
      {
        label: ["Overview", "Overview"],
        path: [privateRoutes.deposit.path],
        key: RBAC_KEY.DEPOSIT,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MY_DEPOSIT_OVERVIEW);
        }
      },
      {
        label: ["Riwayat Top-up", "Top-up History"],
        path: [privateRoutes.depositHistory.path],
        key: RBAC_KEY.DEPOSIT_HISTORY,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MY_DEPOSIT_TOPUP_HISTORY);
        }
      },
      {
        label: ["Laporan Deposit", "Deposit Statement"],
        path: [privateRoutes.depositStatement.path],
        key: RBAC_KEY.DEPOSIT_STATEMENT,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MY_DEPOSIT_STATEMENT);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MY_DEPOSIT);
    }
  },
  refund: {
    label: ["Refund", "Refund"],
    as: Link,
    to: privateRoutes.createRefund.path,
    icon: "redo",
    active_url_prefixes: ["refund"],
    show: true,
    key: PERMISSIONS.REFUND_RBAC,
    childs: [
      {
        label: ["Buat Refund", "Create Refund"],
        path: [privateRoutes.createRefund.path],
        key: RBAC_KEY.REFUND_CREATE,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_REFUND_CREATE);
        }
      },
      {
        label: ["Riwayat Refund", "Refund History"],
        path: [privateRoutes.refund.path],
        key: RBAC_KEY.REFUND_HISTORY,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_REFUND_HISTORY);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_REFUND);
    }
  },
  document: {
    label: ["Dokumen", "Document"],
    as: Link,
    to: privateRoutes.document.path,
    icon: "document",
    active_url_prefixes: ["document"],
    show: true,
    key: RBAC_KEY.DOCUMENT,
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_DOCUMENT);
    }
  },
  user_management: {
    label: ["Kelola Multi Akun", "Manage Multi Account"],
    as: Link,
    to: privateRoutes.userManagement.path,
    icon: "user",
    active_url_prefixes: ["user-management"],
    show: true,
    key: RBAC_KEY.USER_MANAGEMENT,
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_MANAGE_MULTIACCOUNT);
    }
  },
  settings: {
    label: ["Pengaturan", "Settings"],
    as: Link,
    to: privateRoutes.settingsProfileAccount.path,
    icon: "gear",
    active_url_prefixes: ["settings"],
    show: true,
    key: PERMISSIONS.SETTINGS_RBAC,
    childs: [
      {
        label: ["Profil & Akun ", "Profile & Account"],
        path: [privateRoutes.settingsProfileAccount.path],
        key: RBAC_KEY.SETTINGS_PROFILE,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_SETTINGS_PROFILE_ACCOUNT);
        }
      },
      {
        label: ["Notifikasi", "Notification"],
        path: [privateRoutes.settingsNotification.path],
        key: RBAC_KEY.SETTINGS_NOTIFICATION,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_SETTINGS_NOTIFICATION);
        }
      },
      {
        label: ["Transaksi", "Transaction"],
        path: [privateRoutes.settingsTransaction.path],
        key: RBAC_KEY.SETTINGS_TRANSACTION,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_SETTINGS_TRANSACTION);
        }
      },
      {
        label: ["Deposit", "Deposit"],
        path: [privateRoutes.settingsDeposit.path],
        key: RBAC_KEY.SETTINGS_DEPOSIT,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_SETTINGS_TRANSACTION);
        }
      },
      {
        label: ["Keamanan", "Security"],
        path: [privateRoutes.settingsTFA.path],
        key: RBAC_KEY.SETTINGS_TFA_NEW,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_SETTINGS_TFA);
        }
      },
      {
        label: ["Riwayat Aktivitas", "Activity Log"],
        path: [privateRoutes.settingsActivityLog.path],
        key: RBAC_KEY.SETTINGS_ACTIVITY_LOG,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_SETTINGS_ACTIVITY_LOG);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_SETTINGS);
    }
  },
  developer_menu: {
    label: ["Menu Pengembang", "Developer Menu"],
    as: Link,
    to: privateRoutes.settingsApiSetting.path,
    icon: "code",
    active_url_prefixes: ["developer"],
    show: true,
    key: PERMISSIONS.DEVELOPER_RBAC,
    childs: [
      {
        label: ["Kelola API", "Manage API"],
        path: [
          privateRoutes.settingsApiSetting.path,
          privateRoutes.settingsCredentials.path,
          privateRoutes.settingsTwoFactorAuth.path
        ],
        key: RBAC_KEY.SETTINGS_API,
        onClick: () => {
          logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_DEVELOPER_MENU_MANAGE_API);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_DEVELOPER_MENU);
    }
  },
  help_center: {
    ...help_center,
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_HELP_CENTER);
    }
  }
};

export const VERIFICATION_ONLY = {
  help_center: {
    ...help_center,
    onClick: () => {
      logEventClicked(sidebarLiveAnalyticsEvents.SIDEBAR_MENU_HELP_CENTER);
    }
  }
};

export const SANDBOX_ONLY = {
  home: {
    label: ["Beranda", "Home"],
    as: Link,
    to: privateRoutes.sandboxOverview.path,
    icon: "home",
    active_url_prefixes: ["overview"],
    show: true,
    key: RBAC_KEY.SANDBOX_OVERVIEW,
    onClick: () => {
      logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_HOME);
    }
  },
  send_money: {
    label: ["Money Transfer", "Money Transfer"],
    as: Link,
    to: `${privateRoutes.sandboxTransaction.path}`,
    icon: "send",
    active_url_prefixes: ["transaction", "transaction-history"],
    show: true,
    key: PERMISSIONS.SANDBOX_MT_RBAC,
    childs: [
      {
        label: ["Buat Transaksi", "New Transaction"],
        path: [`${privateRoutes.sandboxTransaction.path}`],
        key: RBAC_KEY.SANDBOX_MT_NEW_TRX,
        onClick: () => {
          logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_MONEY_TRANSFER_NEW);
        }
      },
      {
        label: ["Riwayat Transaksi", "Transaction History"],
        path: [privateRoutes.sandboxTransactionHistory.path],
        key: RBAC_KEY.SANDBOX_MT_HISTORY,
        onClick: () => {
          logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_MONEY_TRANSFER_TRANSACTION_HISTORY);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_MONEY_TRANSFER_NEW);
    }
  },
  international_transfer: {
    label: ["International Transfer", "International Transfer"],
    as: Link,
    to: privateRoutes.sandboxInternationalTransactionHistory.path,
    icon: "send-abroad",
    active_url_prefixes: ["international-transaction-history"],
    show: true,
    key: PERMISSIONS.SANDBOX_IT_RBAC,
    childs: [
      {
        label: ["Riwayat Transaksi", "Transaction History"],
        path: [privateRoutes.sandboxInternationalTransactionHistory.path],
        key: RBAC_KEY.SANDBOX_IT_HISTORY,
        onClick: () => {
          logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_INTERNATIONAL_TRANSFER_TRANSACTION_HISTORY);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_INTERNATIONAL_TRANSFER_NEW);
    }
  },
  accept_payment: {
    label: ["Accept Payment", "Accept Payment"],
    as: Link,
    to: privateRoutes.sandboxAcceptPaymentOverview.path,
    icon: "receive",
    active_url_prefixes: ["accept-payment", "accept-payment-history"],
    show: true,
    key: PERMISSIONS.SANDBOX_AP_RBAC,
    childs: [
      {
        label: ["Link Pembayaran", "New Payment Link"],
        path: [privateRoutes.sandboxAcceptPaymentOverview.path],
        key: RBAC_KEY.SANDBOX_ACCEPT_PAYMENT,
        onClick: () => {
          logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_ACCEPT_PAYMENT_NEW);
        }
      },
      {
        label: ["Riwayat Pembayaran", "Payment History"],
        path: [privateRoutes.sandboxAcceptPaymentHistory.path],
        key: RBAC_KEY.SANDBOX_ACCEPT_PAYMENT_HISTORY,
        onClick: () => {
          logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_ACCEPT_PAYMENT_HISTORY);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_ACCEPT_PAYMENT_NEW);
    }
  },
  developer_menu: {
    label: ["Menu Developer", "Developer Menu"],
    as: Link,
    to: privateRoutes.sandboxSnapCredentials.path,
    icon: "code",
    active_url_prefixes: ["credentials", "account-inquiry-history", "verification-history"],
    show: true,
    key: PERMISSIONS.SANDBOX_DEVELOPER_RBAC,
    childs: [
      {
        label: ["Kelola API", "Manage API"],
        path: [privateRoutes.sandboxSnapCredentials.path],
        key: RBAC_KEY.SANDBOX_SNAP_CREDENTIAL,
        onClick: () => {
          logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_DEVELOPER_MENU_MANAGE_API);
        }
      },
      {
        label: ["Riwayat Cek Rekening", "Account Inquiry History"],
        path: [privateRoutes.sandboxAccountInquiryHistory.path],
        key: RBAC_KEY.SANDBOX_ACCOUNT_INQUIRY_HISTORY,
        onClick: () => {
          logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_DEVELOPER_MENU_ACCOUNT_INQUIRY_HISTORY);
        }
      },
      {
        label: ["Riwayat Verifikasi", "Verification History"],
        path: [privateRoutes.sandboxVerificationHistory.path],
        key: RBAC_KEY.SANDBOX_VERIFICATION_HISTORY,
        onClick: () => {
          logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_DEVELOPER_MENU_VERIFICATION_HISTORY);
        }
      }
    ],
    onClick: () => {
      logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_DEVELOPER_MENU);
    }
  },
  help_center: {
    ...help_center,
    onClick: () => {
      logEventClicked(sidebarSandboxAnalyticEvents.SANDBOX_SIDEBAR_MENU_HELP_CENTER);
    }
  }
};
